import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

type Params = {
  startDate?: string;
  endDate?: string;
  status?: string;
  deliveryMethod?: string;
  search?: string;
};

export const useGetMyOrdersQuery = (params: Params) => {
  const token = getToken();

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value)
  );

  return useQuery({
    queryKey: ["useGetMyOrdersQuery", filteredParams],
    queryFn: () =>
      axiosInstance
        .get("orders/drivers/order", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: filteredParams,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
